module.exports = require("@blueprintjs/icons");